import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { store } from './../store'

import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader

import pt from 'vuetify/es5/locale/pt'
import en from 'vuetify/es5/locale/en'
import colors from 'vuetify/es5/util/colors'
Vuetify.config.silent = true
Vue.use(Vuetify)

const redundancia = {
  primary: colors.blue.darken2,
  secondary: colors.grey.darken2,
  accent: colors.blue.accent1,
  error: colors.red.accent2,
  info: colors.blue,
  success: colors.green,
  warning: colors.amber
}

var theme = Object.assign(redundancia, store.getters.theme)

export default new Vuetify({
  theme: theme,
  breakpoint: {
    mobileBreakpoint: 540
  },
  lang: {
    locales: { pt, en },
    current: 'pt'
  },
  icons: {
    iconfont: 'mdi' || 'fa' || 'far' || 'fas' || 'md'
  }
})
